// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_35VCi1xq9FaoJURDe3gWoX","subHeader":"_1t-C-F3w5ARJrKkvbLKP9g","delete":"_2-XaNfVbY9hkXBdrOBknlb","loading":"eE6TfSTcGTqJ71EV5bX-1"};